import React, { Component } from "react";


import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import {
  getMapperFiles,
  setMapperFileLoader,
  deleteMapperFile,
} from "../../../store/mapper/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class UploadHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      editData: null,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getMapperFiles({
      ...this.props.data,
      page: 1,
      sizePerPage: 10,
      ordering: '-created_at',
      results: [],
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) { }

  handleTableChange = data => {
    this.props.getMapperFiles({
      ...data,
      ordering: data.ordering || this.props.data.ordering
    });
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.file_name}"!`,
          onConfirm: () => {
            this.props.deleteMapperFile(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <React.Fragment>
          {this.props.permissions["delete_fileformappingmodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const linkFormatter = (cell, row, data) => {
      return (
        <a
          href={row['data']}
          className="ms-2"
          download
        >
          <NameLink>
            {row['file_name']}
            <StyledDownload className="mdi  mdi-download font-size-22 align-middle text-primary " />
          </NameLink>
        </a>
      );
    };

    const dateFormatter = date => {
      let data = new Date(date).toLocaleString();
      return data;
    };

    const columns = [
      {
        dataField: "file_name",
        text: "File name",
        sort: false,
        formatter: (cell, row) => linkFormatter(cell, row, "file_name"),
      },
      {
        dataField: "user_full_name",
        text: "User",
        sort: true,
        formatter: (cell, row) => row.user_full_name,
      },
      {
        dataField: "created_at",
        text: "Created at",
        sort: true,
        formatter: (cell, row) => dateFormatter(cell, row, "created_at"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Upload history | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Upload history"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  Are you sure you want to delete this history? All transactions will be removed and will no longer be accessible. <br /><br /> If you are not
                  sure, you can close this form.
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const StyledDownload = styled.i`
  opacity: 0.8;
  transition: 0.5s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

UploadHistory.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  getMapperFiles: PropTypes.func,
  setMapperFileLoader: PropTypes.func,
  deleteMapperFile: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.Mapper.mapperFilesData,
  loading: state.Mapper.mapperFilesLoader,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getMapperFiles,
  setMapperFileLoader,
  deleteMapperFile,
})(UploadHistory);
